// extracted by mini-css-extract-plugin
export default {"emails":"emails_emails__rfxMK","pageHeader":"emails_pageHeader__qHQrx","btn":"emails_btn__tv5cy","mobileBtn":"emails_mobileBtn__NFiMU","table":"emails_table__zCOV0"};